import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { ChargesTransaction } from '../../Models/Domains/Transactions/Charges/ChargesTransaction';
import { IJsonDate } from '../../System/IJsonDate';
import { ChargesQueryType } from '../../Models/Domains/Transactions/Charges/ChargesQueryType';
import { ChargesQuerySort } from '../../Models/Domains/Transactions/Charges/ChargesQuerySort';

declare var IS_RUNNING_IN_APP_POOL;

export class ChargesTransactionsClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(hierarchyId: string, fromDate: IJsonDate, toDate: IJsonDate, fromInception: boolean, chargestype: ChargesQueryType, sortby: ChargesQuerySort, sortByAscending: boolean): Promise<Array<ChargesTransaction>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Transaction/ChargesTransactions/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyId: hierarchyId, fromDate: fromDate, toDate: toDate, fromInception: fromInception, chargestype: chargestype, sortby: sortby, sortByAscending: sortByAscending }

    return AjaxWrapper.get<Array<ChargesTransaction>, any>(url, data);
  }
}

